import React, { useEffect } from 'react'
import { Modal, Button } from '@imedcl/design-system'
import { ReactComponent as Error } from '../../assets/img/Group5.svg'
import { useNavigate } from 'react-router-dom'
import { clearStorage } from '../../hooks/clearStorage'

export default function ModalContent() {
  const navigate = useNavigate()
  const { clear } = clearStorage()

  useEffect(() => {
    let sessionActive = localStorage.getItem('session')
    if (!sessionActive) {
      navigate('/')
    }
    //Limpiamos las variables de sesión.
    clear()
  })

  const volver = () => {
    navigate('/')
  }

  return (
    <div className='mt-8'>
      <Modal backgroundClassName='!relative'>
        <React.Fragment key='.0'>
          <div className='mb-6  flex items-center justify-center '>
            <Error width={200}></Error>
          </div>
          <div>
            <h2 className='text-center text-xl text-secondary-imed-100 mb-4'>
              Tiempo de espera agotado
            </h2>
          </div>
          <div>
            <h2 className='text-center text-s text-secondary-imed-100 mb-4'>
              Se ha superado el tiempo máximo de espera para realizar la
              transacción, serás redireccionado al login, donde podrás iniciar
              nuevamente el proceso de pago de facturas.
            </h2>
          </div>
          <div className='flex items-center justify-center'>
            <Button className='m-4' type='secondary' onClick={volver}>
              Volver a Inicio
            </Button>
          </div>
        </React.Fragment>
      </Modal>
    </div>
  )
}
